import React from 'react';
import { Link } from 'react-router-dom';
import useYasna from '../yasna/useYasna';
import '../yasna/Yasna.css';
import './PageShell.css';

/**
 * YasnaDictionaryPage — hoja's dictionary is yasna. This page hosts yasna's
 * own student lookup app (<yasna-dictionary>), loaded live from yasna.
 */
function YasnaDictionaryPage() {
  const { yasna, error } = useYasna();

  return (
    <div className="page-shell">
      <div className="page-shell-inner">
        {error && <p className="yasna-status yasna-status--error">{error}</p>}
        {!error && !yasna && <p className="yasna-status">Loading dictionary…</p>}
        {yasna && <yasna-dictionary />}
        <p className="yasna-status">
          Looking for an entry from before hoja used yasna?{' '}
          <Link to="/dictionary/legacy">Legacy dictionary</Link>
        </p>
      </div>
    </div>
  );
}

export default YasnaDictionaryPage;
